import {
    SET_INSTRUCTOR_FORMS,
    ADD_INSTRUCTOR_FORM,
    UPDATE_INSTRUCTOR_FORM,
    DELETE_INSTRUCTOR_FORM
} from 'store/reducers/instructorReducer'
import moment from 'moment-timezone'
import {apiRequest} from 'util/api/util'

export const loadForms = () => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        // const state = getState()
        const partnerId = getState().instructor.instructor.platformID
        console.log("Loading forms")
        console.log(partnerId)
        return apiRequest("app/forms?partnerId=" + partnerId)
            .then(forms => {
                dispatch({type: SET_INSTRUCTOR_FORMS, forms: forms})
                return forms
            })
    }
}

export const deleteForm = (form) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {

        form = {
            ...form,
            is_enabled: false,
            deleted: true
        }

        return apiRequest("app/form?formId=" + form.id, "PUT", {form: form})
            .then(res => {
                dispatch({type: UPDATE_INSTRUCTOR_FORM, form: res})
                return res
            })
    }
}

export const saveForm = (form) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {

        const state = getState()

        form = {
            ...form,
            partnerId: state.instructor.instructor.platformID,
            deleted: false,
            is_enabled: true
        }

        if (form.id) { // update
            form.updated = moment().unix()

            return apiRequest("app/form?formId=" + form.id, "PUT", {form: form})
                .then(res => {
                    dispatch({type: UPDATE_INSTRUCTOR_FORM, form: res})
                    return res
                })
        } else { // add new
            form.created = moment().unix()
            return apiRequest("app/form", "POST", {form: form})
                .then(res => {
                    dispatch({type: ADD_INSTRUCTOR_FORM, form: res})
                    return res
                })
        }
    }
}